const STAYS = {
  conditions: [
    {
      field: 'body.action',
      operator: 'in',
      value: ['reservation.created', 'reservation.modified', 'reservation.canceled']
    },
    {
      field: 'body.payload.type',
      operator: 'in',
      value: ['booked', 'canceled']
    }
  ],
  action: 'stays',
  type: `rest`,
  payload: {}
}

export default STAYS
